"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _chunkOX4QNVYYjs = require('./chunk-OX4QNVYY.js');

require('./chunk-NESC3UD7.js');

require('./chunk-6R5OOOHC.js');

require('./chunk-R4XHR6A7.js');

require('./chunk-OUWZ2PU5.js');

var _jsxruntime = require('react/jsx-runtime');

var e = _chunkOX4QNVYYjs.c.call(void 0, {
  name: "LinkedinIconMedium",
  size: "Medium",
  svg: _jsxruntime.jsx.call(void 0, "path", {
    d: "M8.92446 26H4.36339V11.3117H8.92446V26ZM6.64147 9.30811C5.18299 9.30811 4 8.10005 4 6.64153C4 5.94095 4.2783 5.26907 4.77367 4.77369C5.26904 4.2783 5.94091 4 6.64147 4C7.34204 4 8.0139 4.2783 8.50928 4.77369C9.00465 5.26907 9.28295 5.94095 9.28295 6.64153C9.28295 8.10005 8.09946 9.30811 6.64147 9.30811ZM25.9951 26H21.4438V18.8498C21.4438 17.1458 21.4095 14.9605 19.0725 14.9605C16.7011 14.9605 16.3377 16.8118 16.3377 18.7271V26H11.7815V11.3117H16.156V13.3153H16.2198C16.8287 12.1613 18.3162 10.9434 20.5354 10.9434C25.1514 10.9434 26 13.9832 26 17.9315V26H25.9951Z"
  }),
  svgElements: ["path"]
});

exports.LinkedinIconMedium = e;